export default theme => (
  {
    label: {
      fontSize: '0.65rem'
    }
  }
);